import React from "react";
import { Field } from "formik";
import { nanoid } from "nanoid";

import styles from "./DateInput.module.scss";

import { FieldPropsType, DateInputPropsType } from "./types";
import {dateMask} from "../../../utils/form/dateMask";

export const DateInput: React.FC<DateInputPropsType> = (props) => {
  const {
    name,
    focusThisInput = false,
    placeholder,
    onChangeFunc,
    isFilledFormsTest,
    label
  } = props;

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  const inputRef = React.useRef<HTMLInputElement>(null);
  const inputId = React.useMemo(() => getInputId(name), [name]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldProps: FieldPropsType,
    name: string
  ) => {
    const { form } = fieldProps;
    const maskedValue = dateMask(e);
    if (onChangeFunc) onChangeFunc({ date: maskedValue });
    form.setFieldValue(name, maskedValue);
  };

  function getInputId(name: string) {
    return `${name}-${nanoid()}`;
  }

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${meta.touched && meta.error ? styles.error : null}
              `}>
              {label}
            </label>
            <input
              ref={inputRef}
              type="text"
              id={name}
              name={field.name}
              value={field.value || ""}
              placeholder={placeholder || "ДД.ММ.ГГГГ"}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
              `}
              onChange={(e) => handleChange(e, fieldProps, name)}
              onBlur={field.onBlur}
              maxLength={10}
            />
          </div>
        );
      }}
    </Field>
  );
};
